export default __webpack_public_path__ + "static/media/fa-solid-900.13de59f1.svg";